import { render } from "./UserViewImage.vue?vue&type=template&id=0a44244e"
import script from "./UserViewImage.vue?vue&type=script&lang=js"
export * from "./UserViewImage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__